module.exports = __webpack_public_path__ + "static/card-education-careers-4-89d134f00c4ef0b03feb79704bdc128e.jpg";